module.exports = __webpack_public_path__ + "static/media/santa_clara_2_big.2d2a0d6c.png";